"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.optSelectOneSchema = exports.reqSelectOneSchema = exports.decimalsTest = exports.NaNtoUndefined = exports.rgx = void 0;
const yup = __importStar(require("yup"));
const rgx = (addChars, space = true) => {
    return new RegExp('^[A-Za-z' + (addChars !== null && addChars !== void 0 ? addChars : '') + (space ? ' ' : '') + ']+$');
};
exports.rgx = rgx;
const NaNtoUndefined = (v) => {
    return isNaN(v) ? undefined : v;
};
exports.NaNtoUndefined = NaNtoUndefined;
const decimalsTest = (precision = 2) => {
    const precisionRgx = `1,${precision}`;
    const rx = new RegExp('^[0-9]+(.[0-9]{' + precisionRgx + '})?$', 'i');
    return {
        name: 'Decimals Test',
        message: `Number should have less then ${precision} decimal places.`,
        test: (v) => {
            return !(!!v && typeof v === 'number' && v.toString().match(rx) === null);
        }
    };
};
exports.decimalsTest = decimalsTest;
function reqSelectOneSchema(possibleValues) {
    return yup.mixed().oneOf(possibleValues).required();
}
exports.reqSelectOneSchema = reqSelectOneSchema;
function optSelectOneSchema(possibleValues) {
    return yup.mixed().oneOf(possibleValues).optional();
}
exports.optSelectOneSchema = optSelectOneSchema;
//# sourceMappingURL=utils.js.map